export const SkeletonVariant = {
  TEXT: 'text',
  RECTANGULAR: 'rectangular',
  ROUND: 'round'
};